export default __webpack_public_path__ + "static/media/EM0740.34I-23430_-15265_0.a19085f8.jpg";